// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2tXta","inputWrap":"styles_inputWrap__1TMVH","input":"styles_input__2jQCK"};